"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePvs = exports.pvsData = exports.resultsDefinition = void 0;
const functions_1 = require("../functions");
const property_1 = require("@genesys/property");
// Every value CoilPro returns for this coil, under CoilPro's own names, so one vocabulary runs
// from the DLL through the schema to the translation key. Errors and warnings are comma-joined
// strings; a coil can calculate successfully and still warn, so an empty warnings cell is the
// only clean result.
exports.resultsDefinition = [
    {
        sortNo: 10,
        propertyName: "errors"
    },
    {
        sortNo: 20,
        propertyName: "warnings"
    },
    {
        sortNo: 30,
        propertyName: "targetreached"
    },
    {
        sortNo: 40,
        propertyName: "marginontotalpower"
    },
    {
        sortNo: 50,
        propertyName: "airpressuredrop"
    },
    {
        sortNo: 60,
        propertyName: "airpressuredropdry"
    },
    {
        sortNo: 70,
        propertyName: "airtotalcapacity"
    },
    {
        sortNo: 80,
        propertyName: "temperatureout"
    },
    {
        sortNo: 90,
        propertyName: "humidityout"
    },
    {
        sortNo: 100,
        propertyName: "pressureout"
    },
    {
        sortNo: 110,
        propertyName: "flow"
    },
    {
        sortNo: 120,
        propertyName: "airvelocity"
    },
    {
        sortNo: 130,
        propertyName: "airstandardvelocity"
    },
    {
        sortNo: 140,
        propertyName: "condensedwater"
    },
    {
        sortNo: 150,
        propertyName: "sensibletotalcapacityratio"
    },
    {
        sortNo: 160,
        propertyName: "marginal"
    },
    {
        sortNo: 170,
        propertyName: "condensingpressure"
    },
    {
        sortNo: 180,
        propertyName: "evaporationpressure"
    },
    {
        sortNo: 190,
        propertyName: "totalfreonpressuredrop"
    },
    {
        sortNo: 200,
        propertyName: "freongaspressuredrop"
    },
    {
        sortNo: 210,
        propertyName: "freonliquidpressuredrop"
    },
    {
        sortNo: 220,
        propertyName: "freonmixedpressuredrop"
    },
    {
        sortNo: 230,
        propertyName: "freonmassflow"
    },
    {
        sortNo: 240,
        propertyName: "freoninletconnectionvelocity"
    },
    {
        sortNo: 250,
        propertyName: "freonoutletconnectionvelocity"
    },
    {
        sortNo: 260,
        propertyName: "freonliquidvelocity"
    },
    {
        sortNo: 270,
        propertyName: "freongasvelocity"
    }
];
const pvsData = (result) => ({
    errors: result.results.errors,
    warnings: result.results.warnings,
    targetreached: String(result.targetReached),
    marginontotalpower: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.marginOnTotalPower)),
    airpressuredrop: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.airPressureDrop)),
    airpressuredropdry: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.airPressureDropDry)),
    airtotalcapacity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.airTotalCapacity)),
    temperatureout: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.temperatureOut)),
    humidityout: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.humidityOut)),
    pressureout: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.pressureOut)),
    flow: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.flow)),
    airvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.airVelocity)),
    airstandardvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.airStandardVelocity)),
    condensedwater: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.condensedWater)),
    sensibletotalcapacityratio: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.sensibleTotalCapacityRatio)),
    marginal: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.marginal)),
    condensingpressure: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.condensingPressure)),
    evaporationpressure: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.evaporationPressure)),
    totalfreonpressuredrop: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.totalFreonPressureDrop)),
    freongaspressuredrop: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.freonGasPressureDrop)),
    freonliquidpressuredrop: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.freonLiquidPressureDrop)),
    freonmixedpressuredrop: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.freonMixedPressureDrop)),
    freonmassflow: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.freonMassFlow)),
    freoninletconnectionvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.freonInletConnectionVelocity)),
    freonoutletconnectionvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.freonOutletConnectionVelocity)),
    freonliquidvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.freonLiquidVelocity)),
    freongasvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.results.freonGasVelocity)),
});
exports.pvsData = pvsData;
const makePvs = (result) => (0, functions_1.collectResults)((0, exports.pvsData)(result));
exports.makePvs = makePvs;
//# sourceMappingURL=results-definition.js.map